// Keep Yinlong's Axios/login interceptors out of JDB requests.
async function request(connection, path, { method = 'GET', body, upload = false, exchange = false } = {}) {
  if (!connection || (!exchange && !connection.access_token)) throw new Error('客服连接已失效，请重新连接');
  const origin = new URL(connection.origin);
  if (origin.protocol !== 'https:' || origin.username || origin.password) throw new Error('客服地址无效');
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), upload ? 60000 : 15000);
  try {
    const headers = { Accept: 'application/json' };
    if (!exchange) headers.Authorization = `External ${connection.access_token}`;
    if (body && !upload) headers['Content-Type'] = 'application/json';
    const response = await window.fetch(`${origin.origin}/api/v1/external_customer_service/${path}`, {
      method, headers, body: body ? (upload ? body : JSON.stringify(body)) : undefined,
      credentials: 'omit', cache: 'no-store', signal: controller.signal,
    });
    const data = await response.json();
    if (!response.ok || !data || data.code !== 1) throw new Error('客服请求失败，请稍后重试');
    return data.result;
  } finally { clearTimeout(timeout); }
}
export const externalCustomerServiceExchange = (connection) => request(connection, 'exchange', { method: 'POST', body: { ticket: connection.ticket }, exchange: true });
export const externalCustomerServiceUnreadRead = (session) => request(session, 'unread/read', { method: 'POST', body: {} });
export const webCustomerServiceConversation = (params, session) => request(session, `conversation${params.before_id ? `?before_id=${encodeURIComponent(params.before_id)}` : ''}`);
export const webCustomerServiceSend = (content, session) => request(session, 'conversation/messages', { method: 'POST', body: { content } });
export const webCustomerServiceAIAction = (action, session) => request(session, 'conversation/ai_action', { method: 'POST', body: { action } });
export const webCustomerServiceMediaURL = (id, session) => request(session, `messages/${encodeURIComponent(id)}/media`);
export const webCustomerServiceSendMedia = (kind, file, session) => {
  const body = new FormData();
  body.append('file', file);
  return request(session, `conversation/media/${kind}`, { method: 'POST', body, upload: true });
};
